import swal from 'sweetalert2'
import router from '../../router/router'
import { API } from '../../services'
import { resetStateToDefault } from '../../utils'
import { configureCongito } from './cognito'

function defaultState () {
  return {
    activateCode: '',
    email: '',
    password: '',

    cognitoInfo: {
      accessToken: null,
      userPoolId: null,
      useCognito: null,
      userPoolWebClientId: null
    }
  }
}

const mutations = {
  resetState (state) {
    resetStateToDefault(state, defaultState())
  },
  activateCode (state, activateCode) {
    state.activateCode = activateCode
  },
  email (state, email) {
    state.email = email
  },
  password (state, password) {
    state.password = password
  }
}

const actions = {
  async registerWithLogin ({ state, dispatch, rootState }) {
    let userPoolId = null, userPoolWebClientId=null, useCognito = null

    if (rootState.accessData.cognitoInfo){
      userPoolId = rootState.accessData.cognitoInfo.userPoolId
      userPoolWebClientId = rootState.accessData.cognitoInfo.userPoolWebClientId
      useCognito = rootState.accessData.cognitoInfo.useCognito
    }

    if (state.email.length < 3 || state.password.length < 4) {
      swal({ type: 'info', text: 'Insira um e-mail e senha válidos' })
      return
    }

    if (useCognito && userPoolId && userPoolWebClientId) {
      let cognitoUser

      try {
        configureCongito({ userPoolId, userPoolWebClientId })
        cognitoUser = await Auth.signIn(state.email, state.password)
      } catch (e) {
        console.warn("Login into cognito failed. Using legacy authentication")
      }

      if (cognitoUser) {
        dispatch('executeRegister', {
          cognitoInfo: {
            accessToken: 'Bearer ' + cognitoUser.signInUserSession.idToken.jwtToken,
            userPoolId,
            userPoolWebClientId
          }
        })
      } else {
        dispatch('executeRegister', {
          email: state.email,
          password: state.password
        })
      }
    } else {
      dispatch('executeRegister', {
        email: state.email,
        password: state.password
      })
    }
  },
  registerWithCode ({ state, dispatch }) {
    const params = {
      code: state.activateCode
    }

    if (state.activateCode.length < 3) {
      swal({type: 'info', text: 'Insira um código de ativação válido'})
      return
    }

    dispatch('executeRegister', params)
  },
  async executeRegister ({ state, commit, dispatch }, {code = null, email = null, password = null, cognitoInfo = null }) {
    let result
    let params = {code: code || undefined, email: email || undefined, password: password || undefined}

    try {
      if (cognitoInfo) {
        commit('cognitoInfo', cognitoInfo, {root: true})
        result = await API.registerCognito.save() // resource will resolve the headers
      } else {
        result = await API.register.save(params)
      }
    } catch (e) {
      const ipNaoAutorizado = e.status === 403 && e.bodyText === 'Esse ip não está autorizado para fazer requisições'
      if (!ipNaoAutorizado) {
        await swal({type: 'error', text: e && e.body && e.body.error ? e.body.error : 'Código inválido'})
        router.push({name: 'clear'})
      }
    }

    const { comp_man, companies } = result.data.success

    commit('setCompMan', comp_man, {root: true})

    if (state.email) {
      commit('chooseCompany/email', state.email, {root: true})
    }


    if (companies.length) {
      commit('chooseCompany/onlyMineGroup', false, {root: true})
      commit('chooseCompany/companies', {loaded: companies}, {root: true})
    } else {
      commit('chooseCompany/onlyMineGroup', true, {root: true})
      dispatch('saveTokensForFirebaseMessaging')
    }

    router.push({name: 'chooseCompany'})
  },
  async registerWithSSO ({state, dispatch, commit}) {
    window.localStorage.clear()

    const result = await API.ssoDevice.get()

    dispatch('setSSOData', result.body)

    commit('punchTimelog/fallback', false, {root: true})

    router.push({name: 'punchTimelog'})
  },
  async registerWithSSOSolar ({state, dispatch, commit}) {
    const result = await API.ssoDevice.get()

    dispatch('setSSOData', result.body)

    commit('punchTimelog/fallback', false, {root: true})

    router.push({name: 'punchTimelog'})
  },
  setSSOData ({ state, commit }, ssoDeviceAPIResponse) {
    commit('setCompMan', ssoDeviceAPIResponse.success.comp_man, {root: true})
    commit('setBrowserRecord', ssoDeviceAPIResponse.success, {root: true})
    commit('punchTimelog/monthPts', ssoDeviceAPIResponse.success.pts, {root: true})
    commit('punchTimelog/todayPts', ssoDeviceAPIResponse.success.dayPts, {root: true})
    commit('punchTimelog/employee', ssoDeviceAPIResponse.success.employee, {root: true})
    commit('punchTimelog/recordVoice', ssoDeviceAPIResponse.success.employee.allowVoice, {root: true})
    commit('punchTimelog/forcarModalDeRequisicaoDeVoz', ssoDeviceAPIResponse.success.employee.forcarModalDeRequisicaoDeVoz, {root: true})
    commit('punchTimelog/doubleCheck', ssoDeviceAPIResponse.success.employee.doubleCheck, {root: true})
    commit('punchTimelog/sessionToken', ssoDeviceAPIResponse.success.sessionToken, {root: true})
    commit('punchTimelog/fallback', false, {root: true})

  }
}

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  mutations
}
